(function($){
    $(document).ready(function() {
        if(window.location.hash == '#changes-saved'){
            bootbox.alert({
                message: "Zapisano zmiany",
                backdrop: false, // Brak przysłaniania ekranu
                closeButton: false // Brak przycisku zamknięcia
            });

            setTimeout(function() {
                bootbox.hideAll(); // Ukryj wszystkie notyfikacje
                window.location.hash = '';
            }, 3000); // 5000 milisekund = 5 sekundy
        }
    });
})(jQuery)